/* Ferseng: rugs placed in a room with true perspective (homography -> CSS matrix3d). */
(function () {
  'use strict';

  function solve(A, b) {
    var n = b.length, i, j, k;
    for (i = 0; i < n; i++) A[i] = A[i].concat([b[i]]);
    for (i = 0; i < n; i++) {
      var max = i;
      for (k = i + 1; k < n; k++) if (Math.abs(A[k][i]) > Math.abs(A[max][i])) max = k;
      var tmp = A[i]; A[i] = A[max]; A[max] = tmp;
      for (k = i + 1; k < n; k++) {
        var f = A[k][i] / A[i][i];
        for (j = i; j <= n; j++) A[k][j] -= f * A[i][j];
      }
    }
    var x = new Array(n);
    for (i = n - 1; i >= 0; i--) {
      var s = A[i][n];
      for (j = i + 1; j < n; j++) s -= A[i][j] * x[j];
      x[i] = s / A[i][i];
    }
    return x;
  }

  function homography(src, dst) {
    var A = [], b = [];
    for (var i = 0; i < 4; i++) {
      var x = src[i][0], y = src[i][1], X = dst[i][0], Y = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -x * X, -y * X]); b.push(X);
      A.push([0, 0, 0, x, y, 1, -x * Y, -y * Y]); b.push(Y);
    }
    return solve(A, b);
  }

  var ORIENT = {
    // Image corners in order TL, TR, BR, BL, as fractions of the stage.
    along: [[0.40, 0.655], [0.60, 0.655], [0.72, 0.94], [0.28, 0.94]],
    across: [[0.66, 0.66], [0.80, 0.93], [0.20, 0.93], [0.34, 0.66]]
  };

  function Room(stage) {
    this.stage = stage;
    this.rug = stage.querySelector('[data-room-rug], .room-rug');
    this.photo = stage.querySelector('[data-room-photo]');
    this.drawn = stage.querySelector('[data-room-drawn]');
    this.editable = stage.hasAttribute('data-room-edit');
    this.orient = stage.getAttribute('data-orient') || 'along';
    this.pts = clone(ORIENT[this.orient]);
    this.handles = [];
    if (!this.rug) return;
    var ratio = parseFloat(this.rug.getAttribute('data-ratio')) || 0.75;
    this.w = 600; this.h = Math.round(600 / ratio);
    this.rug.style.width = this.w + 'px';
    this.rug.style.height = this.h + 'px';
    if (this.editable) this.buildHandles();
    var self = this;
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.draw(); }).observe(stage);
    window.addEventListener('resize', function () { self.draw(); });
    this.draw();
  }

  function clone(a) { return a.map(function (p) { return [p[0], p[1]]; }); }

  Room.prototype.draw = function () {
    var W = this.stage.clientWidth, H = this.stage.clientHeight;
    if (!W || !H) return;
    var dst = this.pts.map(function (p) { return [p[0] * W, p[1] * H]; });
    var m = homography([[0, 0], [this.w, 0], [this.w, this.h], [0, this.h]], dst);
    this.rug.style.transform = 'matrix3d(' + [m[0], m[3], 0, m[6], m[1], m[4], 0, m[7], 0, 0, 1, 0, m[2], m[5], 0, 1].join(',') + ')';
    this.rug.classList.add('is-placed');
    this.handles.forEach(function (h, i) {
      h.style.left = (this.pts[i][0] * 100) + '%';
      h.style.top = (this.pts[i][1] * 100) + '%';
    }, this);
    if (this.onDraw) this.onDraw(this.pts, W, H);
  };

  Room.prototype.setPoints = function (pts) { this.pts = clone(pts); this.draw(); };

  Room.prototype.buildHandles = function () {
    var self = this;
    var names = ['far left', 'far right', 'near right', 'near left'];
    for (var i = 0; i < 4; i++) {
      (function (i) {
        var h = document.createElement('button');
        h.type = 'button';
        h.className = 'room-handle';
        h.setAttribute('aria-label', 'Rug corner ' + (i + 1) + ', use arrow keys to move');
        h.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          h.setPointerCapture(e.pointerId);
          h.classList.add('is-dragging');
          function move(ev) {
            var r = self.stage.getBoundingClientRect();
            self.pts[i] = [
              Math.min(1.05, Math.max(-0.05, (ev.clientX - r.left) / r.width)),
              Math.min(1.05, Math.max(-0.05, (ev.clientY - r.top) / r.height))
            ];
            self.draw();
          }
          function up() {
            h.classList.remove('is-dragging');
            h.removeEventListener('pointermove', move);
            h.removeEventListener('pointerup', up);
            h.removeEventListener('pointercancel', up);
          }
          h.addEventListener('pointermove', move);
          h.addEventListener('pointerup', up);
          h.addEventListener('pointercancel', up);
        });
        h.addEventListener('keydown', function (e) {
          var d = e.shiftKey ? 0.04 : 0.01, p = self.pts[i];
          if (e.key === 'ArrowLeft') p[0] -= d;
          else if (e.key === 'ArrowRight') p[0] += d;
          else if (e.key === 'ArrowUp') p[1] -= d;
          else if (e.key === 'ArrowDown') p[1] += d;
          else return;
          e.preventDefault();
          self.draw();
        });
        self.stage.appendChild(h);
        self.handles.push(h);
      })(i);
    }
  };

  Room.prototype.reset = function () { this.pts = clone(ORIENT[this.orient]); this.draw(); };
  Room.prototype.rotate = function () {
    this.orient = this.orient === 'along' ? 'across' : 'along';
    this.reset();
  };
  Room.prototype.clearLayers = function () {
    this.stage.querySelectorAll('.room-layer').forEach(function (n) { n.remove(); });
    this.onDraw = null;
  };
  Room.prototype.fitToPhoto = function () {
    var p = this.photo, st = this.stage;
    if (!p || !p.naturalWidth) return;
    var r = p.naturalWidth / p.naturalHeight;
    st.style.aspectRatio = String(r);
    st.style.maxWidth = 'min(100%, calc(70vh * ' + r.toFixed(4) + '))';
    st.style.marginInline = 'auto';
    this.draw();
  };
  Room.prototype.usePhoto = function (file) {
    if (!file || !this.photo) return Promise.resolve();
    var self = this;
    if (this._url) URL.revokeObjectURL(this._url);
    this._url = URL.createObjectURL(file);
    this.clearLayers();
    this.photo.hidden = false;
    if (this.drawn) this.drawn.hidden = true;
    this.stage.classList.add('has-photo');
    return new Promise(function (res) {
      self.photo.onload = function () { self.fitToPhoto(); self.reset(); res(); };
      self.photo.onerror = function () { res(); };
      self.photo.src = self._url;
    });
  };
  Room.prototype.useDrawn = function () {
    if (this._url) { URL.revokeObjectURL(this._url); this._url = null; }
    this.clearLayers();
    this.stage.style.aspectRatio = ''; this.stage.style.maxWidth = ''; this.stage.style.marginInline = '';
    var def = this.photo && this.photo.getAttribute('data-default-src');
    if (def) {
      this.photo.src = def;
      this.photo.hidden = false;
      if (this.drawn) this.drawn.hidden = true;
      this.stage.classList.add('has-photo');
    } else {
      if (this.photo) { this.photo.hidden = true; this.photo.removeAttribute('src'); }
      if (this.drawn) this.drawn.hidden = false;
      this.stage.classList.remove('has-photo');
    }
    this.reset();
  };

  /* Size of the rug in feet, from the size the shopper has picked on the page. */
  function pickedSize(tool) {
    var re = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i, m = null;
    document.querySelectorAll('[data-product-form] input[type="radio"]:checked, [data-product-form] select').forEach(function (el) {
      if (!m) m = re.exec(el.value || '');
    });
    if (!m) m = re.exec(tool.getAttribute('data-size') || '');
    if (!m) return { len: 9, wid: 6, label: '6 × 9 ft' };
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { len: Math.max(a, b), wid: Math.min(a, b), label: Math.min(a, b) + ' × ' + Math.max(a, b) + ' ft' };
  }

  /* Find the floor in the shopper's photo and lay the rug on it (runs on the device). */
  function autoPlace(tool, room, file) {
    var src = tool.getAttribute('data-ai-src');
    var status = tool.querySelector('[data-room-status]');
    var say = function (t) { if (status) { status.textContent = t; status.hidden = !t; } };
    if (!src || !room.photo || room.photo.hidden) return Promise.resolve();
    var run = (room._run = (room._run || 0) + 1);
    var size = pickedSize(tool);
    tool.classList.add('is-working');
    say(tool.getAttribute('data-msg-working') || 'Finding the floor…');
    return import(src).then(function (ai) {
      return Promise.resolve(file ? ai.lensFov(file) : null).then(function (fov) {
        return ai.autoPlace(room.photo, {
          lenFt: size.len, widFt: size.wid, hfov: fov || 69,
          onProgress: function (p) {
            var f = room._files || (room._files = {});
            f[p.model + p.file] = [p.loaded, p.total];
            var l = 0, t = 0; Object.keys(f).forEach(function (k) { l += f[k][0]; t += f[k][1]; });
            if (t > 2097152) say((tool.getAttribute('data-msg-loading') || 'Preparing the room view') + ' · ' + Math.min(99, Math.round(l / t * 100)) + '%');
          }
        }).then(function (res) { return { ai: ai, res: res }; });
      });
    }).then(function (o) {
      if (run !== room._run) return;
      var res = o.res;
      room.clearLayers();
      if (!res.ok) { say(tool.getAttribute('data-msg-fail') || 'We could not see enough open floor. Drag the corners to place the rug.'); return; }
      var shade = o.ai.shadingCanvas(res.analysis); shade.className = 'room-layer room-layer--shade';
      var occ = o.ai.occluderCanvas(room.photo, res.analysis); occ.className = 'room-layer room-layer--occ';
      room.stage.appendChild(shade); room.stage.appendChild(occ);
      room.onDraw = function (pts) {
        shade.style.clipPath = 'polygon(' + pts.map(function (p) { return (p[0] * 100).toFixed(2) + '% ' + (p[1] * 100).toFixed(2) + '%'; }).join(',') + ')';
      };
      room.setPoints(res.corners);
      say((tool.getAttribute('data-msg-done') || 'Placed at its real size') + ': ' + size.label + '. ' + (tool.getAttribute('data-msg-adjust') || 'Drag the corners to fine-tune.'));
    }).catch(function () {
      if (run === room._run) say(tool.getAttribute('data-msg-error') || 'Automatic placement is not available on this device. Drag the corners to place the rug.');
    }).then(function () { tool.classList.remove('is-working'); });
  }

  function initTool(tool) {
    var stage = tool.querySelector('[data-room-stage]');
    if (!stage || stage._room) return;
    var room = stage._room = new Room(stage);
    var file = tool.querySelector('[data-room-upload]');
    var lastFile = null;
    if (file) file.addEventListener('change', function () {
      lastFile = file.files[0];
      if (!lastFile) return;
      room.usePhoto(lastFile).then(function () { return autoPlace(tool, room, lastFile); });
    });
    tool.querySelectorAll('[data-room-auto]').forEach(function (b) { b.addEventListener('click', function () { autoPlace(tool, room, lastFile); }); });
    if (room.photo && !room.photo.hidden) {
      if (room.photo.complete && room.photo.naturalWidth) room.fitToPhoto();
      else room.photo.addEventListener('load', function () { room.fitToPhoto(); }, { once: true });
    }
    tool.querySelectorAll('[data-room-rotate]').forEach(function (b) { b.addEventListener('click', function () { room.rotate(); }); });
    tool.querySelectorAll('[data-room-reset]').forEach(function (b) { b.addEventListener('click', function () { room.reset(); }); });
    tool.querySelectorAll('[data-room-sample]').forEach(function (b) { b.addEventListener('click', function () {
      if (file) file.value = '';
      lastFile = null;
      room._run = (room._run || 0) + 1;
      var st = tool.querySelector('[data-room-status]'); if (st) { st.textContent = ''; st.hidden = true; }
      room.useDrawn();
      if (room.photo && !room.photo.hidden) room.photo.addEventListener('load', function () { room.fitToPhoto(); }, { once: true });
    }); });
    var light = tool.querySelector('[data-room-light]');
    if (light) light.addEventListener('input', function () { room.rug.style.filter = 'brightness(' + light.value + '%) drop-shadow(0 1px 1px rgba(40, 25, 5, .35))'; });
  }

  function initSpots(root) {
    root.querySelectorAll('[data-room-spot]').forEach(function (spot) {
      if (spot._bound) return;
      spot._bound = true;
      var card = document.getElementById(spot.getAttribute('aria-controls'));
      spot.addEventListener('click', function () {
        var open = spot.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-room-spot][aria-expanded="true"]').forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          var c = document.getElementById(o.getAttribute('aria-controls'));
          if (c) c.hidden = true;
        });
        if (!open && card) { spot.setAttribute('aria-expanded', 'true'); card.hidden = false; }
      });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-room-tool]').forEach(initTool);
    root.querySelectorAll('[data-room-stage]:not([data-room-edit])').forEach(function (s) { if (!s._room) s._room = new Room(s); });
    initSpots(root);
    root.querySelectorAll('[data-room-open]').forEach(function (b) {
      if (b._bound) return;
      b._bound = true;
      var dlg = document.getElementById(b.getAttribute('data-room-open'));
      if (!dlg || typeof dlg.showModal !== 'function') return;
      b.addEventListener('click', function () {
        dlg.showModal();
        var s = dlg.querySelector('[data-room-stage]');
        if (s && s._room) requestAnimationFrame(function () { s._room.draw(); });
      });
      dlg.querySelectorAll('[data-room-close]').forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });
  }

  window.FersengRoom = { Room: Room, init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
